import { resetMainPageCache } from '@/composables/useMainPageCache'
import { resetDailyBriefingCache } from '@/composables/useDailyBriefing'
import { resetNamingPurchaseHistory } from '@/composables/saju-insight/useNamingPurchaseHistory'

// 컴포넌트/페이지 sessionStorage 캐시 키 모음
// 키 정의가 컴포넌트 파일에 있어 직접 import 어려움 → 여기서 단일 출처로 관리
const SESSION_CACHE_KEYS = [
  'primary-saju-cache',
  'saju-service-list-cache',
  'saju-service-group-cache',
  'purchaseList',
  'printData',
  'printformData',
  'giftingData',
  'oauth_link_state',
]

const LOCAL_CACHE_KEYS = [
  'tempFormData',
]

/**
 * 로그아웃/계정 전환 시 모든 모듈 레벨 + sessionStorage 캐시를 일괄 초기화한다.
 * 토큰 제거(`store/modules/user.js` logout)와 함께 호출되어야 한다.
 */
export function clearAllUserCaches() {
  resetMainPageCache()
  resetDailyBriefingCache()
  resetNamingPurchaseHistory()

  try {
    SESSION_CACHE_KEYS.forEach((key) => sessionStorage.removeItem(key))
    LOCAL_CACHE_KEYS.forEach((key) => localStorage.removeItem(key))
  } catch {}

  // 메인페이지 등 마운트 중인 컴포넌트에 캐시 리셋 사실을 알려 재조회 트리거
  try {
    if (typeof window !== 'undefined') {
      window.dispatchEvent(new CustomEvent('nangman:user-caches-reset'))
    }
  } catch {}

  // Pinia store 캐시 — Pinia가 활성화된 상태에서만 동적 import 후 reset
  Promise.all([
    import('@/store/modules/primarySaju').then(({ usePrimarySajuStore }) =>
      usePrimarySajuStore().reset(),
    ),
    import('@/store/modules/analysisDataStore').then(({ useAnalysisDataStore }) =>
      useAnalysisDataStore().resetAll(),
    ),
    import('@/store/modules/mobileSajuLnb').then(({ useMobileSajuLnbStore }) =>
      useMobileSajuLnbStore().resetMobileSajuStore(),
    ),
    // 회원 정보 (헤더 smartwel 로고, 마이페이지 oauthAccounts 등)
    import('@/store/modules/myinfo').then(({ useMyInfoStore }) =>
      useMyInfoStore().resetMyInfo(),
    ),
    // 결제/포인트 (포인트 충전 페이지 파트너 전환 UI 등)
    import('@/store/modules/payments').then(({ usePaymentsStore }) =>
      usePaymentsStore().clearPaymentsInfo(),
    ),
  ]).catch(() => {})
}
